import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=e7e8e87c&scoped=true"
import script from "./NotificationList.vue?vue&type=script&lang=js"
export * from "./NotificationList.vue?vue&type=script&lang=js"
import style0 from "./NotificationList.vue?vue&type=style&index=0&id=e7e8e87c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e8e87c",
  null
  
)

export default component.exports